import React from "react";
import PropTypes from "prop-types";
import { Chip, Avatar, Grid, LinearProgress } from "@material-ui/core";
import DocStore from "../stores/DocStore";
import { withStyles } from "@material-ui/core/styles";
import DocRequiredField from './DocRequiredField'

const fileInfo = f => {
  const nameSplit = f.split("/").pop();
  const name = nameSplit.replace(/%CC%81/g, '').replace(/%CC%83/g, '');
  return name.split(".");
};

const styles = {
  root: {
    paddingTop: 8,
    "@media print": {
      "&:before":{
        content: "Archivos Adjuntos:"
      }
    }
  }
};

class AttachThings extends React.Component {
  constructor(props) {
    super(props);
    this.input = React.createRef();
    this.state = { uploading: 0 };
  }
  shouldComponentUpdate(nextProps, nextState) {
    const tprops = this.props;
    return (
      tprops.open !== nextProps.open ||
      tprops.files.length !== nextProps.files.length ||
      (nextState.uploading > 0 && nextState.uploading < 100)
    );
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.open) {
      this.input.current.click();
      this.props.onClose();
    }
  }

  onProgress = pc => {
    this.setState({uploading:pc});
    (pc===100 || pc===0) ? this.props.isUploading(false) : this.props.isUploading(true);
  };

  render() {
    const { files, classes, onDelete, readOnly, preview } = this.props;
    const { uploading } = this.state;
    let message = null;

    if(files.length > 0){
      message = (
        <div style={{ display: 'flex', flexDirection: 'column-reverse' }}>
          <DocRequiredField valid={readOnly? true : false} message={'*Es importante que se conserve en su computadora el respaldo de los archivos adjuntos en este oficio.'} />
        </div>
      );
    }

    if (uploading > 0 && uploading < 100)
      return (
        <LinearProgress variant="determinate" value={this.state.uploading} />
      );
    return (
      <Grid container spacing={8} className={classes.root}>
        {files.map((f, i) => {
          const info = fileInfo(f);
          return (
            <Grid item key={i} >

              <strong className={"printable"}> Archivos adjuntos: </strong>
              <Chip
                className={preview? "preview_text" : "text_atachmentts" }
                avatar={<Avatar>{info[1]}</Avatar>}
                onClick={e => {
                  DocStore.downloadAttacment(f);
                }}
                label={info[0].length>=30?info[0].slice(0,30)+"...": info[0]}
                onDelete={
                  readOnly
                    ? null
                    : e => {
                        onDelete(f);
                      }
                }
              />
            </Grid>
          );
        })}
        {message}
        <input
          type="file"
          className="hidden"
          ref={this.input}
          onChange={e => this.props.onChange(e, this.onProgress)}
          multiple
          value=""
        />
      </Grid>
    );
  }
}

export default withStyles(styles)(AttachThings);
AttachThings.propTypes = {
  open: PropTypes.bool.isRequired,
  files: PropTypes.array.isRequired,
  onClose: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  isUploading: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./src/components/AttachThings.js